import React from 'react';
import PropTypes from 'prop-types';
import { SmallSpinner } from 'shared-components/decorators/spinner';

export class AJAXOptionButton extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      submitted: false
    };
    this.toggleSubmitted = this.toggleSubmitted.bind(this);
    this.clickFn = this.clickFn.bind(this);
  }

  toggleSubmitted (p) {
    return this.setState({ submitted: p });
  }

  clickFn (e) {
    e.preventDefault();
    if (!this.props.clickCallback) {
      return this.props.clickAction();
    }
    this.toggleSubmitted(true);
    this.props.clickAction(e.target.parentElement, (...args) => {
      setTimeout(() => {
        this.toggleSubmitted(false);
        $('.btn').blur();
        this.props.clickCallback(...args);
      }, 0);
    });
  }

  render () {
    const textOpacityVal = this.state.submitted ? 0 : 1;
    return (
      <button
        id={this.props.id}
        style={{ minWidth: this.props.minWidth }}
        disabled={this.state.submitted ? 'disabled' : ''}
        onClick={this.clickFn}
        className={`relative ${this.props.buttonClass}`}
      >
        <span style={{ opacity: textOpacityVal }}>{this.props.buttonText}</span>
        <SmallSpinner show={this.state.submitted} color={this.props.spinnerColor} />
      </button>
    );
  }
}

AJAXOptionButton.propTypes = {
  clickAction: PropTypes.func.isRequired,
  buttonText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object // compiled JSX
  ]),
  clickCallback: PropTypes.func,
  buttonClass: PropTypes.string,
  spinnerColor: PropTypes.string,
  minWidth: PropTypes.string,
  id: PropTypes.string
};

AJAXOptionButton.defaultProps = {
  buttonClass: 'btn btn-lg btn-primary form',
  buttonText: 'Submit'
};
